/* eslint-disable no-script-url */
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useContext, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import Button from '../../components/Button';
import DefaultCard from '../../components/DefaultCard';
import EditableAvatar from '../../components/EditableAvatar';
import MenuTabs from '../../components/MenuTabs';
import { AuthStore } from '../../providers/auth';
import { ProfileProvider } from '../../providers/profile';
import { getAllAddressesMappedByType } from '../../services/addresses';
import { getAllProfiles } from '../../services/profiles';
import BeneficiariesContent from '../widgets/beneficiaries/BeneficiariesContent';
import Beneficiaries from './beneficiaries';
import HsaInvestment from './hsa-investment';
import AddressTabContent from './profileTabPages/addressTab';
import BankingTabContent from './profileTabPages/bankingTab';
import ComunicationsTabContent from './profileTabPages/communicationTab';
import EmailTabContent from './profileTabPages/emailTab';
import FamilyMembersWrapper from './profileTabPages/familyMembersTab';
import LoginRecoveryTabContent from './profileTabPages/loginRecoveryTab';
import PhoneTabContent from './profileTabPages/phoneTab';

function ProfileView() {
  const [searchParams] = useSearchParams();
  const [mainUser] = getAllProfiles().data.filter(
    (profile) => profile.relationship === 'self'
  );

  const addresses = getAllAddressesMappedByType();

  const [, , , selectedPersona] = useContext(AuthStore) || [];

  const [workEmail, setWorkEmail] = useState<any>({
    type: 'work',
    email: 'terry.smith@work.com',
  });

  const [personalEmail, setPersonalEmail] = useState<any>({
    type: 'personal',
    email: 'terry.smith@email.com',
  });

  const [isWorkEmailChecked, setIsWorkEmailChecked] = useState(true);
  const [isPersonalEmailChecked, setIsPersonalEmailChecked] = useState(false);

  const [homePhone, setHomePhone] = useState<any>({
    type: 'home',
    phone: '(555) 112-1234',
  });

  const [workPhone, setWorkPhone] = useState<any>({
    type: 'work',
    phone: '(555) 212-2345',
  });

  const [mobilePhone, setMobilePhone] = useState<any>({
    type: 'mobile',
    phone: '(555) 312-3456',
  });

  const [isHomePhoneChecked, setIsHomePhoneChecked] = useState(true);
  const [isWorkPhoneChecked, setIsWorkPhoneChecked] = useState(false);
  const [isMobilePhoneChecked, setIsMobilePhoneChecked] = useState(false);

  const [verified, setVerified] = React.useState(false);

  const [workAddress, setWorkAddress] = useState<any>(addresses.work[0]);

  const [alternateAddress, setAlternateAddress] = useState<any>(
    addresses.alt[0]
  );

  const [homeAddress, setHomeAddress] = useState<any>(addresses.home[0]);

  const [isHomeAddressChecked, setIsHomeAddressChecked] = useState(true);
  const [isWorkAddressChecked, setIsWorkAddressChecked] = useState(false);
  const [isAlternateAddressChecked, setIsAlternateAddressChecked] =
    useState(false);

  const [bankCheckingAccount, setbankCheckingAccount] = React.useState<any>({
    id: '1',
    name: 'Wells Fargo Bank',
    iban: '1234123412',
    routingNumber: '034802454',
    accountNumber: '4321433412',
    type: 'Savings',
    accountNickname: 'Main Account',
  });

  const [bankSavingsAccount, setbankSavingsAccount] = React.useState<any>({
    id: '2',
    name: 'Bank of America',
    iban: '4321432143',
    routingNumber: '034804444',
    accountNumber: '1112341234',
    type: 'Cheking',
    accountNickname: 'Family funds',
  });

  const tabsData = [
    {
      name: 'Address',
      content: (
        <AddressTabContent
          workAddress={workAddress}
          setWorkAddress={setWorkAddress}
          alternateAddress={alternateAddress}
          setAlternateAddress={setAlternateAddress}
          homeAddress={homeAddress}
          setHomeAddress={setHomeAddress}
          isHomeAddressChecked={isHomeAddressChecked}
          setIsHomeAddressChecked={setIsHomeAddressChecked}
          isWorkAddressChecked={isWorkAddressChecked}
          setIsWorkAddressChecked={setIsWorkAddressChecked}
          isAlternateAddressChecked={isAlternateAddressChecked}
          setIsAlternateAddressChecked={setIsAlternateAddressChecked}
        />
      ),
      icon: <FontAwesomeIcon icon={light('map-location-dot')} />,
      href: '#/profile/address',
    },
    {
      name: 'Email',
      content: (
        <EmailTabContent
          workEmail={workEmail}
          setWorkEmail={setWorkEmail}
          personalEmail={personalEmail}
          setPersonalEmail={setPersonalEmail}
          isWorkEmailChecked={isWorkEmailChecked}
          isPersonalEmailChecked={isPersonalEmailChecked}
          setIsWorkEmailChecked={setIsWorkEmailChecked}
          setIsPersonalEmailChecked={setIsPersonalEmailChecked}
        />
      ),
      icon: <FontAwesomeIcon icon={light('at')} />,
      href: '#/profile/email',
    },
    {
      name: 'Phone',
      content: (
        <PhoneTabContent
          homePhone={homePhone}
          setHomePhone={setHomePhone}
          workPhone={workPhone}
          setWorkPhone={setWorkPhone}
          mobilePhone={mobilePhone}
          setMobilePhone={setMobilePhone}
          verified={verified}
          setVerified={setVerified}
          isHomePhoneChecked={isHomePhoneChecked}
          setIsHomePhoneChecked={setIsHomePhoneChecked}
          isWorkPhoneChecked={isWorkPhoneChecked}
          setIsWorkPhoneChecked={setIsWorkPhoneChecked}
          isMobilePhoneChecked={isMobilePhoneChecked}
          setIsMobilePhoneChecked={setIsMobilePhoneChecked}
        />
      ),
      icon: <FontAwesomeIcon icon={light('phone')} />,
      href: '#/profile/phone',
    },
    {
      name: 'Communications',
      content: <ComunicationsTabContent />,
      icon: <FontAwesomeIcon icon={light('bullhorn')} />,
      href: '#/profile/communication',
    },
    {
      name: 'Banking',
      content: (
        <BankingTabContent
          bankCheckingAccount={bankCheckingAccount}
          setbankCheckingAccount={setbankCheckingAccount}
          bankSavingsAccount={bankSavingsAccount}
          setbankSavingsAccount={setbankSavingsAccount}
        />
      ),
      icon: <FontAwesomeIcon icon={light('bank')} />,
      href: '#/profile/banking',
    },
    {
      name: 'Beneficiaries',
      content: <BeneficiariesContent />,
      icon: <FontAwesomeIcon icon={light('hands-holding-dollar')} />,
      href: '#/profile/beneficiaries',
    },
    {
      name: 'Family Members',
      content: <FamilyMembersWrapper />,
      icon: <FontAwesomeIcon icon={light('family')} />,
      href: '#/profile/familymembers',
    },
    {
      name: 'Login & Recovery',
      content: <LoginRecoveryTabContent />,
      icon: <FontAwesomeIcon icon={light('lock-open')} />,
      href: '#/profile/login',
    },
  ];

  const currentPersonaTabsData = tabsData.filter((e) => {
    if (selectedPersona === 'persona-db') {
      return e.name !== 'Family Members';
    }

    return e;
  });

  return (
    <>
      {!searchParams.get('q') && (
        <Container
          className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}
        >
          <Row className={'mt-7 mt-lg-13 justify-content-between'}>
            <Col className={'col-12 col-lg-4'}>
              <EditableAvatar
                defaultAvatar={`${process.env.PUBLIC_URL}/${mainUser.image}`}
                variant={'static'}
              >
                <Fragment>
                  <h4 className={'text-sm-24-lg-32  fw-bold'}>
                    {mainUser.name}
                  </h4>
                  <span className={'fw-normal'}>04/04/1972</span>
                  <span className={'mt-3 fw-normal text-dark-gray'}>
                    Married
                  </span>
                </Fragment>
              </EditableAvatar>
            </Col>
            <Col className={'col-12 col-lg-5 mt-11 mt-lg-0'}>
              <DefaultCard
                variant="blue-motif"
                leftHeading="Access your benefits anywhere, any time"
                button={
                  <Button variant="primary-shadow" size="sm">
                    Download Now
                  </Button>
                }
              />
            </Col>
          </Row>
          <Row className={'mt-7 mt-lg-13'}>
            <Col className={'col-12 col-3'}>
              <MenuTabs tabs={currentPersonaTabsData} />
            </Col>
            <Col></Col>
          </Row>
        </Container>
      )}
      {searchParams.get('q') === 'hsa' && <HsaInvestment />}
      {searchParams.get('q') === 'beneficiaries' && <Beneficiaries />}
    </>
  );
}

function Dashboard() {
  return (
    <ProfileProvider>
      <ProfileView />
    </ProfileProvider>
  );
}

export default Dashboard;
